import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReports from '../reducer/reports.reducer';

export const selectReportsFeature = createFeatureSelector<fromReports.ReportsState>(fromReports.reportsFeatureKey);

const { selectEntities, selectAll } = fromReports.reportsAdapter.getSelectors();

export const selectReportsEntities = createSelector(selectReportsFeature, selectEntities);

export const selectReports = createSelector(selectReportsFeature, selectAll);

export const selectError = createSelector(selectReportsFeature, state => state.baseState.error);

export const selectIsLoading = createSelector(selectReportsFeature, state => state.baseState.isLoading);

export const selectPageNumber = createSelector(selectReportsFeature, state => state.baseState.pageNumber);

export const selectPageSize = createSelector(selectReportsFeature, state => state.baseState.pageSize);
